export default {
  SET_ORDERS: function (state, orders) {
    state.orders = orders;
  }
}
